export default {"src":"/_next/static/media/ecm-legal-zoom.f84cd345.svg","height":38,"width":240};